const layout = {
  slug: 'layout',
  getStayConnected: () => `${layout.slug}/get-stay-connected-info`
}

export default { layout }
